import type { PlatformActionRequest } from '../models/platformAction.types'
import { adaptActionRequest } from '../service/adaptActionRequest'
import { classifyError } from '../service/classifyError'

import type { DecideActionApi, DetailActionStore, FlowResult } from './platformActionFlow.types'

export interface DecideActionFlowDeps {
  api: DecideActionApi
  store: DetailActionStore
}

/** The two non-approving decisions. `INVALID_ACTION_STATE` (409) means the request already moved on. */
export type ActionDecision = 'reject' | 'cancel'

export class DecideActionFlow {
  constructor(private readonly deps: DecideActionFlowDeps) {}

  async execute(
    workspaceId: number,
    actionId: string,
    decision: ActionDecision,
    comment?: string,
    signal?: AbortSignal,
  ): Promise<FlowResult<PlatformActionRequest>> {
    try {
      const result =
        decision === 'reject'
          ? await this.deps.api.reject(workspaceId, actionId, comment, signal)
          : await this.deps.api.cancel(workspaceId, actionId, signal)
      const request = adaptActionRequest(result.request)
      this.deps.store.patchRequest(request)
      return { ok: true, value: request }
    } catch (cause) {
      return { ok: false, error: classifyError(cause) }
    }
  }
}
